<template>
  <div id="app">
    <!-- <AppNavbar v-if="isAuthenticated" /> -->
     <AppNavbar/>

    <main role="main">
      <router-view />
    </main>

    <AppFooter :compact="isChatRoute" :hide-on-mobile="isChatRoute" />

    <DebugPanel v-if="isDevelopment" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppNavbar from '@/components/layout/AppNavbar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import DebugPanel from '@/components/common/DebugPanel.vue'
import logger from '@/utils/logger'

const isDevelopment = process.env.NODE_ENV === 'development'

export default {
  name: 'App',
  components: {
    AppNavbar,
    AppFooter,
    DebugPanel
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    isDevelopment() {
      return isDevelopment
    },
    isChatRoute() {
      return this.$route?.name === 'Chat'
    }
  },
  async mounted() {
    try {
      await this.initializeAuth()
    } catch (error) {
      logger.error('Auth initialization failed', { error: error.message })
    }
  },
  methods: {
    ...mapActions('auth', ['initializeAuth'])
  }
}
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
}

main {
  min-height: 0;
  overflow-y: auto;
}
</style>
